module.exports = __webpack_public_path__ + "img/hero-image.3e661591.webp";